import { Heading, Text, theme } from '@hhgtech/hhg-components'

import { getHelloSitesUrl } from 'api/utils/paths'
import { DetailStatistic } from 'components/atoms/detailStatistic'
import { useRouterExtend } from 'hooks/useRouterExtend'

import { CommunitySectionProps } from '../communitySection'
import { StyledCommunitySection } from '../index.styled'
import { TopicScrollList } from './topicScrollList'

export const CommunitySectionMobile = ({
  community,
  topics,
  title,
  message,
  actionButton,
}: CommunitySectionProps) => {
  const { locale } = useRouterExtend()

  if (!community) return null

  return (
    <StyledCommunitySection>
      <div className="thumbnail-header">
        <img
          loading="lazy"
          className="thumbnail"
          src={community.thumbnail}
          alt="thumbnail"
        />
        <div>
          <a
            href={`/community/${community?.slug}`}
            data-event-category="Together"
            data-event-action="Community Title Click"
            data-event-label={`${getHelloSitesUrl(locale)}/community/${
              community?.slug
            }`}
            className="pointer-event-child-none"
          >
            <Heading
              tag="h5"
              fontWeight="bold"
              color={theme.colors.gray800}
              className="grow"
            >
              {title}
            </Heading>
          </a>
          <div className="detail-general">
            <DetailStatistic
              postsCount={community.postsCount}
              membersCount={community.membersCount}
            />
          </div>
        </div>
      </div>
      <div className="detail">
        {message && (
          <div className="detail-message">
            <Text size="p3" color={theme.colors.gray800}>
              {message}
            </Text>
          </div>
        )}
        <div className="detail-tag">
          <TopicScrollList topics={topics} communitySlug={community.slug} />
        </div>
      </div>
      {actionButton && <div>{actionButton}</div>}
    </StyledCommunitySection>
  )
}
